export const CAR_FOR_COMPARE_SELECTED = "car_compare";
export const CAR_FAVORITE_SELECTED = "car_favorite";
export const SELECTED_LANGUAGE = "language";

export const UsedCarFilter = "usedcar_filter";
export const UsedCarFilterNearby = "usedcar_filter_nearby"
export const VehicleViewedHistory = "vehicle_viewed_history";
